import { render, staticRenderFns } from "./ContentCustomServiceBox.vue?vue&type=template&id=6d1e92da&"
import script from "./ContentCustomServiceBox.vue?vue&type=script&lang=js&"
export * from "./ContentCustomServiceBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports